import React, { useEffect } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { UpdatePaymentFormValuesType } from "./UpdatePaymentDialogFormWrapper";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";

type Props = {
  formikProps: FormikProps<UpdatePaymentFormValuesType>;
  onClose: () => void;
  totalamount:any
};

const UpdatePaymentDialogForm = ({ formikProps, onClose , totalamount }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  useEffect(()=>{ 
    const newIntallmentAmount = totalamount - values?.receviedAmount
    setFieldValue("amount", newIntallmentAmount)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[values?.receviedAmount])

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Update Payment</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Received Amount */}
        <div>
          <ATMTextField
            name="receviedAmount"
            value={values?.receviedAmount}
            onChange={(e) => {
              setFieldValue("receviedAmount", e.target.value);
              
            }}
            label="Received Amount"
            placeholder="Enter Received Amount"
            onBlur={handleBlur}
          />
        </div>
        {/* Amount */}
        <div>
          <ATMTextField
            name="amount"
            disabled
            value={values?.amount}
            onChange={(e) => {
              setFieldValue("amount", e.target.value);
            }}
            label="Amount (To Take)"
            placeholder="Enter Amount"
            onBlur={handleBlur}
          />
        </div>
        {/* Due Date */}
        <div>
          <ATMDatePicker
            format="DD-MM-YYYY"
            name="dueDate"
            value={values?.dueDate}
            onChange={(newValue) => setFieldValue(`dueDate`, newValue)}
            label="Due Date"
          />
        </div>
          {/* Remark */}
          <div className="">
            <ATMTextArea
              name="remark"
              value={values.remark}
              onChange={(newValue) => setFieldValue("remark", newValue)}
              label="Remark"
              placeholder="Enter Remark"
              onBlur={handleBlur}
            />
          </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default UpdatePaymentDialogForm;
